<template>
  <div class="reward-fix">
    <v-input
      :placeholder="$t('components.Profile.fixedSum')"
      typeName="number"
      v-model="model"
      @blur="$emit('blur')"
      :error="error"
      :disabled="disabled"
    ></v-input>
    <div class="reward-preview" v-if="+value > 0">
      <div class="reward-preview__item">
        <span class="reward-preview__icon reward-preview__icon--gold"></span>
        <span>gold: {{(+value * 0.8).toFixed(2)}}</span>
      </div>
      <div class="reward-preview__item">
        <span class="reward-preview__icon reward-preview__icon--silver"></span>
        <span>silver: {{(+value * 0.5).toFixed(2)}}</span>
      </div>
      <div class="reward-preview__item">
        <span class="reward-preview__icon reward-preview__icon--classic"></span>
        <span>classic: {{(+value * 0.3).toFixed(2)}}</span>
      </div>
    </div>
  </div>
</template>

<script>
import vInput from '@/ui/controls/vInput'

export default {
  props: {
    value: {
      type: [String, Number],
      default: null
    },
    error: {
      type: String,
      default: null
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },

  components: {
    vInput
  },

  computed: {
    model: {
      get () {
        return this.value
      },

      set (val) {
        if (!val) {
          val = null
          return this.$emit('input', null)
        }
        return this.$emit('input', +val)
      }
    }
  }
}
</script>

<style lang="scss">
  .reward-preview {
    display: flex;
    flex-wrap: wrap;

    &--inactive > * {
      visibility: hidden;
    }

    &__item {
      display: flex;
      align-items: center;
      margin-right: 15px;
      padding-top: .5rem;
    }

    &__icon {
      border-radius: 50px;
      width: 14px;
      height: 14px;
      background: #CCCCCC;
      display: inline-block;
      margin-right: 5px;

      &--gold {
        background: linear-gradient(155.41deg,#ad9723 -4.4%,#dad76a 52.72%,#ad9723 109.83%);
      }

      &--silver {
        background: linear-gradient(155.41deg,#515151 -4.4%,#b9b9b9 52.72%,#585858 109.83%);
      }

      &--classic {
        background: linear-gradient(159.97deg,#20d0ff,#8d98fc 52.06%,#9f4fe3);
      }
    }
  }
</style>
